import { logOut } from "../services/AuthService";
import { Wrench, Hammer } from "lucide-react";

export default function Maintenance() {
  const handleLogout = () => {
    logOut();
  };

  return (
    <div className="fixed inset-0 bg-white flex flex-col items-center justify-center z-50 px-4">
      <div className="text-center max-w-lg">
        {/* Icon in circle */}
        <div className="w-32 h-32 bg-primary-300/30 rounded-full flex items-center justify-center mb-8 mx-auto">
          <div className="relative">
            <Wrench className="w-12 h-12 text-primary-700 transform rotate-45" />
            <Hammer className="w-10 h-10 text-primary-700 absolute -top-1 -right-1 transform -rotate-45" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-4xl font-bold mb-6 text-primary-800">
          We're under maintenance
        </h1>

        {/* Subtitle */}
        <p className="text-primary-700 text-lg mb-8 leading-relaxed">
          Our website is down for maintenance. We will be back shortly.
        </p>

        {/* Buttons */}
        <div className="flex gap-4 justify-center">
          <button
            onPointerDown={() => window.location.reload()}
            className="bg-gray-100 text-gray-700 hover:bg-gray-200 px-8 py-3 rounded-lg font-semibold transition-colors duration-200"
          >
            Refresh
          </button>
          <button
            onPointerDown={handleLogout}
            className="bg-primary-600 text-white hover:bg-primary-700 px-8 py-3 rounded-lg font-semibold transition-colors duration-200"
          >
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
}
